import { CommanderThunkAction, AsyncAction } from '@mews-commander/types';
import { createFetchAction } from '@mews-commander/utils';
import { setAvailabilityAdjustments } from '@mews-commander/legacy-entities/src/ducks/availabilityAdjustments';
import { SERVICE_AVAILABILITIES_FETCH } from '../actionTypes';

export const fetchAvailabilities =
    ({
        startUtc,
        endUtc,
        serviceId,
    }: {
        startUtc: string;
        endUtc: string;
        serviceId: string;
    }): CommanderThunkAction<AsyncAction> =>
    async (dispatch, getState, { repositories }) => {
        const promise = repositories.services
            .getAvailabilities({ firstTimeUnitStartUtc: startUtc, lastTimeUnitStartUtc: endUtc, serviceId })
            .then(({ availabilities }) => {
                const adjustments = availabilities
                    .flatMap(({ blockAdjustmentData }) => blockAdjustmentData ?? [])
                    .map(({ availabilityBlockAdjustment }) => availabilityBlockAdjustment);
                dispatch(setAvailabilityAdjustments(adjustments));
                return availabilities;
            });

        return dispatch(createFetchAction(SERVICE_AVAILABILITIES_FETCH, promise));
    };
